import Litepicker from 'litepicker';
import 'litepicker/dist/plugins/keyboardnav';
import 'litepicker/dist/plugins/mobilefriendly';
export default class MarcDatePicker {
    skip = null;
    datePicker = null;

    /***
     * @Plugin LitePicker
     * @link https://litepicker.com/
     * @github https://github.com/wakirin/litepicker/
     */
    constructor(form) {
        this.form = form;
        const {'start-date': startDate, 'end-date': endDate} = this.form;
        const isMobile = UX.grid.screenXs >= window.innerWidth;
        this.litepickerIns = new Litepicker({
            element: startDate,
            elementEnd: endDate,
            singleMode: false,
            allowRepick: true,
            numberOfMonths: isMobile ? 1 : 2,
            numberOfColumns: isMobile ? 1 : 2,
            plugins: ['keyboardnav', 'mobilefriendly'],
            lang: document.documentElement.lang || 'de-DE',
            resetButton: true,
            tooltipText: {
                one: startDate?.dataset?.day || 'day',
                other: startDate?.dataset?.days || 'days',
            },
            autoApply: !isMobile,
            setup: picker => {
                picker.on(
                    'render',
                    function (datePicker) {
                        this._handleA11ySkipBtn(datePicker);
                    }.bind(this)
                );
                picker.on('show', () => this.skip.focus());
                picker.on('change:month', this._handleA11yChangeMonth.bind(this));
                picker.on('hide', this._handleA11yNextElement.bind(this));
            },
            buttonText: {
                apply: startDate?.dataset?.applyDate || 'Apply',
                cancel: startDate?.dataset?.cancelDate || 'Cancel',
                previousMonth: `
                        <svg width="11" height="16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path d="M7.919 0l2.748 2.667L5.333 8l5.334 5.333L7.919 16 0 8z" fill-rule="nonzero"></path>
                        </svg>
                        <span class="sr-only">${startDate?.dataset?.prevMonth || 'Previous month'}</span>
                    `,
                nextMonth: `
                        <svg width="11" height="16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path d="M2.748 16L0 13.333 5.333 8 0 2.667 2.748 0l7.919 8z" fill-rule="nonzero"></path>
                        </svg>
                        <span class="sr-only">${startDate?.dataset?.nextMonth || 'Next month'}</span>
                    `,
                reset: `
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" aria-hidden="true">
                            <path d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"></path>
                      </svg>
                      <span class="sr-only">${startDate?.dataset?.resetDate || 'Reset date'}</span>
                    `,
            },
        });
    }

    /**
     * @A11Y === Accessibility FUNCTIONS
     * @private
     */
    _handleA11yLitePickerHide() {
        this.litepickerIns.hide();
    }
    _handleA11yNextElement() {
        const nextFocusElement = this.form.querySelector(this.skip.hash);
        nextFocusElement?.focus();
    }
    _handleA11yChangeMonth() {
        const nextOrPrevBrn = this.datePicker.querySelectorAll(`.${event.target.className}`);
        if (nextOrPrevBrn.length > 0) {
            if (event.target.classList.contains('button-previous-month')) {
                nextOrPrevBrn[0]?.focus();
            } else {
                nextOrPrevBrn[1]?.focus();
            }
        }
    }
    _handleA11ySkipBtn(datePicker) {
        const {'start-date': startDate} = this.form;
        const skipBtnText = startDate?.dataset?.skipDate || 'Skip date picker';

        datePicker.insertAdjacentHTML(
            'afterbegin',
            `<a href="#marc-continue" id="skip-litepicker" tabindex="1" class="sr-only"> ${skipBtnText} </a>`
        );
        this.skip = datePicker.querySelector('#skip-litepicker');
        this.skip.addEventListener('click', this._handleA11yLitePickerHide.bind(this));
        this.skip.addEventListener('keydown', this._handleA11ySkipToTop.bind(this, event));
        this.datePicker = datePicker;
    }
    _handleA11ySkipToTop() {
        /**
         * @38 Top Arrow
         * @9 Enter
         */
        if ((event.shiftKey && event.keyCode === 9) || event.keyCode === 38) {
            this._handleA11yLitePickerHide();
            if (this.form.isbn && !this.form.isbn.disabled) {
                this.form.isbn.focus();
            } else if (this.form?.type?.length) {
                const lastRadioBtn = this.form.type[this.form.type.length - 1];
                lastRadioBtn.focus();
            }
        }
    }
}
